import { InjectionToken, WritableSignal } from '@angular/core';

import { TellentClientConfig } from '../client';
import type { TellentBrand, TellentCurrentUser } from '../types';

export const ORG_GUID = new InjectionToken<string | null>('Authorized organization GUID');
export const APP_GUID = new InjectionToken<string | null>('Authorized app GUID');
export const TELLENT_SUITE_ENABLED = new InjectionToken<boolean>('Tellent Suite feature flag');
export const TELLENT_NOT_AUTHORIZED = new InjectionToken<boolean>('Tellent not authorized');
export const BRAND = new InjectionToken<TellentBrand>(
  'Current brand in the context of the organization',
);
export const TELLENT_CURRENT_USER = new InjectionToken<TellentCurrentUser>(
  'Current user in the context of the organization',
);

export type TellentAdoptedStylesheetsSignal = WritableSignal<CSSStyleSheet[]>;
export const TELLENT_ADOPTED_STYLESHEETS = new InjectionToken<TellentAdoptedStylesheetsSignal>(
  'TELLENT_ADOPTED_STYLESHEETS',
);

export const TELLENT_CLIENT_CONFIG = new InjectionToken<TellentClientConfig>(
  'TELLENT_CLIENT_CONFIG',
);
